// loading-overlay.component.ts
import { Component } from '@angular/core';
import { FuseLoadingService } from '@fuse/services/loading/loading.service';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'app-loading-overlay',
    templateUrl: './loading-overlay.html',
    styleUrls: ['./loading-overlay.scss'],
})
export class LoadingOverlayComponent {
    // push the first emission out of the initial CD cycle
    show$: Observable<boolean> = this._loadingService.show$.pipe(delay(0));

    constructor(private _loadingService: FuseLoadingService) {}
}
